import {ApiOperationError, HttpError} from '@di-nxt/resource-container';

export const getHttpStatusCode = (error: Error): number | undefined => {
  return error instanceof ApiOperationError &&
    error.innerError instanceof HttpError
    ? error.innerError.status
    : undefined;
};
